import React, { useState, useCallback } from 'react';
import { useDispatch } from "react-redux";
import ReactDOM from 'react-dom'
import Cropper from 'react-easy-crop';
// import './styles.css'
import { Card } from '../../pages/Theme';
import { apiUrl, apiMainUrl, serverUrl } from "../Helpers/Config";
import axios from "axios";
import { setUserPhoto, setUserCover, setUserPinned } from "../../redux/actions/auth";
import { useEffect } from 'react';
import { tokenAuthorize } from '../Helpers/Common';
import ButtonCommon from "../../components/Button/ButtonCommon";
import Button from '../Button/Button';

const createImage = (url) =>
    new Promise((resolve, reject) => {
        const image = new Image()
        image.addEventListener('load', () => resolve(image))
        image.addEventListener('error', (error) => reject(error))
        image.setAttribute('crossOrigin', 'anonymous') // needed to avoid cross-origin issues on CodeSandbox
        image.src = url
    })

function getRadianAngle(degreeValue) {
    return (degreeValue * Math.PI) / 180
}

/**
 * Returns the new bounding area of a rotated rectangle.
 */
function rotateSize(width, height, rotation) {
    const rotRad = getRadianAngle(rotation)

    return {
        width:
            Math.abs(Math.cos(rotRad) * width) + Math.abs(Math.sin(rotRad) * height),
        height:
            Math.abs(Math.sin(rotRad) * width) + Math.abs(Math.cos(rotRad) * height),
    }
}


async function getCroppedImg(
    imageSrc,
    pixelCrop,
    rotation = 0,
    flip = { horizontal: false, vertical: false }
) {
    const image = await createImage(imageSrc)
    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')

    if (!ctx) {
        return null
    }

    const rotRad = getRadianAngle(rotation)

    // calculate bounding box of the rotated image
    const { width: bBoxWidth, height: bBoxHeight } = rotateSize(
        image.width,
        image.height,
        rotation
    )

    // set canvas size to match the bounding box
    canvas.width = bBoxWidth
    canvas.height = bBoxHeight

    // translate canvas context to a central location to allow rotating and flipping around the center
    ctx.translate(bBoxWidth / 2, bBoxHeight / 2)
    ctx.rotate(rotRad)
    ctx.scale(flip.horizontal ? -1 : 1, flip.vertical ? -1 : 1)
    ctx.translate(-image.width / 2, -image.height / 2)

    // draw rotated image
    ctx.drawImage(image, 0, 0)

    // croppedAreaPixels values are bounding box relative
    // extract the cropped image using these values
    const data = ctx.getImageData(
        pixelCrop.x,
        pixelCrop.y,
        pixelCrop.width,
        pixelCrop.height
    )

    // set canvas width to final desired crop size - this will clear existing context
    canvas.width = pixelCrop.width
    canvas.height = pixelCrop.height

    // paste generated rotate image at the top left corner
    ctx.putImageData(data, 0, 0)

    // As Base64 string
    // return canvas.toDataURL('image/jpeg');

    // As a blob
    return new Promise((resolve, reject) => {
        canvas.toBlob((file) => {
            resolve(URL.createObjectURL(file))
        }, 'image/jpeg')
    })
}

const ModalProfileFeature = ({ show, setShow, imgSrc, setshowModalFeature, setfeatureImage }) => {

    const dispatch = useDispatch()

    const [dataShow, setdataShow] = useState(false)

    // useEffect(() => {
    //     setdataShow(show)
    // }, [show])

    const showHideModal = show
        ? 'fixed top-0 left-0 w-full h-full bg-black bg-opacity-60 block modelIndex'
        : 'fixed top-0 left-0 w-full h-full bg-black bg-opacity-60 hidden'

    const [crop, setCrop] = useState({ x: 0, y: 0 })
    const [zoom, setZoom] = useState(1)
    const [rotation, setRotation] = useState(0)
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null)
    const [croppedImage, setCroppedImage] = useState(null)

    const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels)
    }, [])

    const showCroppedImage = useCallback(async () => {
        try {
            const croppedImage = await getCroppedImg(
                imgSrc,
                croppedAreaPixels,
                rotation
            )
            setCroppedImage(croppedImage);
            getBlobData(croppedImage);
            // if (editBanner == true || editCover == true || imgCommunity === true) {
            //     getBlobData(croppedImage);
            // }
            // if (editCover == false && editBanner == false) {
            //     var blob = dataURItoBlob(croppedImage);
            //     const formData = new FormData();

            //     const xhr = new XMLHttpRequest();
            //     xhr.open('GET', croppedImage, true);
            //     xhr.responseType = 'blob';

            //     xhr.onload = () => {
            //         formData.append('file', xhr.response, 'filename.png');
            //         updateProfilePhoto(formData)
            //     };
            //     xhr.send();
            // }

        } catch (e) {
            console.error(e)
        }
    }, [croppedAreaPixels, rotation])

    function dataURItoBlob(dataURI) {
        // convert base64/URLEncoded data component to raw binary data held in a string
        var byteString;
        if (dataURI.split(',')[0].indexOf('base64') >= 0)
            byteString = atob(dataURI.split(',')[1]);
        else
            byteString = unescape(dataURI.split(',')[1]);

        // separate out the mime component
        var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

        // write the bytes of the string to a typed array
        var ia = new Uint8Array(byteString.length);
        for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }

        return new Blob([ia], { type: mimeString });
    }

    const getBlobData = (file) => {
        axios({
            method: "get",
            url: file, // blob url eg. blob:http://127.0.0.1:8000/e89c5d87-a634-4540-974c-30dc476825cc
            responseType: "blob",
        }).then(function (response) {
            var reader = new FileReader();
            reader.readAsDataURL(response.data);
            reader.onloadend = function () {
                var base64data = reader.result;
                updateProfilePhoto(base64data);
            }
        });
    }

    const removeCroppedImage = () => {
        setShow(false)
    }

    const updateProfilePhoto = (fileObj) => {
        setfeatureImage(fileObj)
        setShow(false)
        setshowModalFeature(false)
    }

    return (
        <div className={showHideModal} onClick={(e) => e.stopPropagation()}>
            <section className="fixed transform -translate-y-2/4 -translate-x-2/4 top-2/4 left-2/4">
                <Card className="w-80 md:w-full bg-white px-4 md:px-8 py-5 my-5 rounded-md filter drop-shadow-md" style={{ width: '600px', height: '600px' }}>
                    <div className="">
                        <div className='control-button d-flex justify-content-end h-20'><Button className='cancel-Apply' style={"h-full"} onClick={removeCroppedImage} title={"Cancel"}></Button>&nbsp;&nbsp;<ButtonCommon className='button-Apply pl-3 px-10 py-3' onClick={showCroppedImage} title="Apply"></ButtonCommon></div>
                        <div className="crop-container">
                            <Cropper
                                image={imgSrc}
                                crop={crop}
                                zoom={zoom}
                                cropShape={"rect"}
                                aspect={3 / 2}
                                onCropChange={setCrop}
                                onCropComplete={onCropComplete}
                                onZoomChange={setZoom}
                            />
                        </div>
                        <div className="controls">
                            <input
                                type="range"
                                value={zoom}
                                min={1}
                                max={3}
                                step={0.1}
                                aria-labelledby="Zoom"
                                onChange={(e) => {
                                    setZoom(e.target.value)
                                }}
                                className="zoom-range"
                            />
                        </div>
                    </div>
                </Card>
            </section>
        </div>
    )
}

export default ModalProfileFeature;